import React, { useState } from 'react';
import { useRecordContext } from 'react-admin';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
} from '@mui/material';

const formatDate = (dateString) =>
  dateString ? new Date(dateString).toLocaleDateString() : 'N/A';
const getNested = (obj, path) =>
  path.split('.').reduce((acc, part) => acc?.[part], obj);

const LabelValue = ({ label, value }) => (
  <>
    <Grid item xs={4}>
      <Typography variant="body2" fontWeight="bold" color="textSecondary">
        {label}
      </Typography>
    </Grid>
    <Grid item xs={8}>
      <Typography variant="body2">{value ?? 'N/A'}</Typography>
    </Grid>
  </>
);

const UserDialog = ({ source, path = '', }) => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);
  const [cityName, setCityName] = useState(null);
  const [serviceNames, setServiceNames] = useState([]);
  const [subCatNames, setSubCatNames] = useState([]);
  const token = JSON.parse(localStorage.getItem("token"));
  const person = path
    ? getNested(record, path)
    : record;


  if (!person) return null;
  const handleOpen = () => {
    setOpen(true);

    fetchCityName(person.city); // optional: if cities are available via a similar endpoint
    fetchServiceTypeNames(person.service_id).then(setServiceNames);
    fetchSubCategoryNames(person.subCategory_id).then(setSubCatNames);
  };

  const handleClose = () => setOpen(false);



  const fetchCityName = async (id) => {
    try {
      const res = await fetch(
        `https://apiecr.mahsool.sd/admin/city?${id}`
      );
      const data = await res.json();

      setCityName(data[id - 1].name);


    } catch (err) {

      console.error('Failed to load city:', err);
    }
  };
  const fetchServiceTypeNames = async (ids = []) => {
    if (ids.length === 0) return [];

    try {
      const res = await fetch(
        `https://apiuat.mahsool.sd/admin/servicetypes`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      const data = await res.json();
      return data?.data?.map((item) => item.name) || [];
    } catch (err) {
      console.error('Failed to fetch service types:', err);
      return [];
    }
  };
  const fetchSubCategoryNames = async (ids = []) => {
    if (ids.length === 0) return [];

    try {
      const res = await fetch(
        `https://apiuat.mahsool.sd/admin/sub_category`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      const data = await res.json();
      return data?.data?.map((item) => item.name) || [];
    } catch (err) {
      console.error('Failed to fetch subcategories:', err);
      return [];
    }
  };

  return (
    <>
      <Typography
        onClick={handleOpen}
        variant="body2"
        color="primary"
        sx={{ textDecoration: 'underline', cursor: 'pointer', display: 'inline' }}
      >
        {person.name}
      </Typography>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{`${source.charAt(0).toUpperCase() + source.slice(1)} Details`}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <LabelValue label="Name" value={person.name} />
            <LabelValue label="Phone Number" value={person.phonenumber} />
            <LabelValue label="City" value={cityName} />
            <LabelValue label="Type" value={person.type} />
            <LabelValue label="Gender" value={person.gender} />
            <LabelValue label="Services" value={serviceNames.join(', ') || 'N/A'} />
            <LabelValue label="Subcategories" value={subCatNames.join(', ') || 'N/A'} />
            <LabelValue label="Cooperative Type" value={person.cooperativeType} />
            <LabelValue label="No. of Members" value={person.NoOfMembers} />
            <LabelValue label="Subscribed At" value={formatDate(person.subscribed_at)} />
            <LabelValue label="Is Subscribed" value={person.isSubscribed ? 'Yes' : 'No'} />
            <LabelValue label="Is Verified" value={person.isVerified ? 'Yes' : 'No'} />
            <LabelValue label="Date of Birth" value={formatDate(person.dob) ?? 'N/A'} />
            <LabelValue label="Created At" value={formatDate(person.created_at)} />
            <LabelValue label="Updated At" value={formatDate(person.updated_at)} />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserDialog;